import { render, staticRenderFns } from "./VirtualAssistantEventsFilters.vue?vue&type=template&id=642fd5ad&"
import script from "./VirtualAssistantEventsFilters.vue?vue&type=script&lang=js&"
export * from "./VirtualAssistantEventsFilters.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAssistantEventsFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports